<div
  class="component"
  [ngClass]="{ 'with-tranche-details': !!selectedMaturityId }"
>
  <span
    class="empty"
    [hidden]="!(emptyMessage | async)"
    [textContent]="emptyMessage | async"
  >
  </span>
  <div class="tableWrapper" [hidden]="!!(emptyMessage | async)">
    <ag-grid-angular
      class="ag-theme-cupcake monitor-table"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event, columnDefinitions)"
      (rowClicked)="onSelectMaturity($event)"
      (sortChanged)="preserveCustomSorting($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      [rowData]="data | async"
      [pinnedTopRowData]="[totals | async]"
    >
    </ag-grid-angular>
  </div>
</div>
